export const serializeFilters = (filters: any[]) => {
    return filters
        .map((group) => {
            return group.filters
                .map((filter: any) => {
                    const { columnKey, operator, value } = filter;
                    return `${columnKey} ${operator} (${value})`;
                })
                .join(' | ');
        })
        .join(' | ');
};

export const deserialiseFilters = (serializedString: string) => {
    const filters = serializedString.split(' | ').map((filterString) => {
        // Match the filter pattern: columnKey OPERATOR (value)
        const match = filterString.match(/^(.+?)\s+([A-Z]+)\s+\((.+)\)$/);

        if (!match) {
            throw new Error(`Invalid filter format: ${filterString}`);
        }

        const [, columnKey, operator, value] = match;

        return {
            columnKey,
            operator,
            value: operator === 'BETWEEN' ? value.split('TO') : value, // Split BETWEEN into an array if applicable
        };
    });

    // Group by columnKey to match the grouped structure
    const groupedFilters = filters.reduce((acc: any, filter) => {
        const existingGroup = acc.find((group: any) => group.columnKey === filter.columnKey);
        if (existingGroup) {
            existingGroup.filters.push(filter);
        } else {
            acc.push({
                columnKey: filter.columnKey,
                filters: [filter],
            });
        }
        return acc;
    }, []);

    return groupedFilters;
};
